// @flow
import React, {Fragment, PureComponent, type ComponentType} from 'react';
import ReactResizeDetector from 'react-resize-detector';
import Experiment, {On, Off} from '@homeaway/react-experiment';
import {get} from 'lodash';
import TravelerBannerContainer from '../TravelerBannerContainer/TravelerBannerContainer';
import AppDownloadBanner from '../AppDownloadBanner/AppDownloadBanner';
import GlobalBannerContainer from '../GlobalBannerContainer/GlobalBannerContainer';
import GDPRBanner from '../GDPRBanner/GDPRBanner';
import type {Size} from '../../actions/topBanners';
import type {State as AbacusState} from '../../reducers/abacus';
import type {SystemData} from '../../../server/utils/systemData';
import type {SearchRequestQueryResponseData} from '../../queries/searchRequestQuery';
import cookies from 'js-cookie';

import './withTopBanners.less';
import {VRBO_WEB_GLOBAL_MESSAGING_BANNER} from '../../abacus/experiments';

export type Props = {
    onTopBannersSizeChanged: (Size) => any,
    abacus: AbacusState,
    siteName: string,
    fullLocale: string,
    system: SystemData,
    onResize: Function,
    data: SearchRequestQueryResponseData
};

export default function withTopBanners<OwnProps: {}>(
    WrappedComponent: ComponentType<$Supertype<OwnProps>>
): ComponentType<Props> {
    return class TopBanners extends PureComponent<Props> {
        getGDPRBannerVersion = () => {
            const {
                abacus: {ha_gdpr_banner: experiment}
            } = this.props;

            if (
                experiment &&
                experiment.bucket &&
                experiment.bucket.bucketConfig
            ) {
                const {
                    bucket: {bucketConfig}
                } = experiment;

                return bucketConfig;
            }

            return null;
        };

        onResize = (width, height) => {
            this.props.onTopBannersSizeChanged({
                height
            });
        };

        globalMessageBannerNotExists = (globalMessages) => {
            let globalMessageId = get(globalMessages, 'banner.id', null);
            globalMessageId =
                typeof globalMessageId === 'string' ? globalMessageId : null;
            let globalMsgBannerDismissed =
                globalMessageId &&
                cookies.get(`ha-global-banner-${globalMessageId}`)
                    ? true
                    : false;
            return !globalMessageId || globalMsgBannerDismissed;
        };

        render() {
            const {fullLocale, data, siteName, system} = this.props;
            const {results} = data || {};
            const {globalMessages} = results || {};
            const gdprBannerVersion = this.getGDPRBannerVersion();
            const globalMessageBannerNotExists = this.globalMessageBannerNotExists(
                globalMessages
            );

            return (
                <Fragment>
                    <div className="TopBanners">
                        {gdprBannerVersion && (
                            <GDPRBanner
                                fullLocale={fullLocale}
                                bannerVersion={gdprBannerVersion}
                            />
                        )}
                        <Experiment name={VRBO_WEB_GLOBAL_MESSAGING_BANNER}>
                            <On>
                                <GlobalBannerContainer
                                    globalMessages={globalMessages}
                                />
                            </On>
                            <Off>
                                <TravelerBannerContainer />
                            </Off>
                        </Experiment>
                        {globalMessageBannerNotExists && system.isMobile && (
                            <AppDownloadBanner
                                fullLocale={fullLocale}
                                siteName={siteName}
                            />
                        )}
                        <ReactResizeDetector
                            handleHeight
                            onResize={this.onResize}
                        />
                    </div>
                    <WrappedComponent {...this.props} />
                </Fragment>
            );
        }
    };
}
